<div class="view-wrapper">
  <div class="panels">
    <dk-left-side-panel class="left-side-panel">
      <div class="left-side-panel-content">
        <dx-button
          stylingMode="contained"
          type="danger"
          text="Kapat"
          style="margin-left: 16px"
          (onClick)="goBack()"
        ></dx-button>
        <div class="buttons">
          <dx-button
            text="Bugün"
            (onClick)="onSelectedDateChange()"
          ></dx-button>
          <dx-button
            text="Etkinlik oluştur"
            type="default"
            (onClick)="showAppointmentCreationForm()"
          ></dx-button>
        </div>
        <div class="calendar">
          <dx-calendar
            [value]="currentDate"
            (valueChange)="onCalendarDateChange($event)"
          ></dx-calendar>
        </div>
        <dk-calendar-list
          [dataSource]="listDataSource"
          (listSelectionChanged)="calendarListChanged($event)"
        ></dk-calendar-list>
      </div>
    </dk-left-side-panel>

    <div class="scheduler-container">
      <dx-scheduler
        #schedulerRef
        height="inherit"
        [adaptivityEnabled]="!!(screen.screenChanged | async)?.isXSmall"
        [allDayPanelMode]="'hidden'"
        [dataSource]="tasks"
        [currentView]="currentView"
        [currentDate]="getSchedulerCurrentDate | apply : currentDate"
        [startDayHour]="4"
        [showCurrentTimeIndicator]="false"
        (currentViewChange)="onCurrentViewChange($event)"
        (onAppointmentClick)="onAppointmentClick($event)"
        (onAppointmentTooltipShowing)="onAppointmentTooltipShowing($event)"
        (onCellClick)="onCellClick($event)"
      >
        <dxi-resource
          fieldExpr="calendarId"
          label="Takvim"
          [dataSource]="resourcesList"
        >
        </dxi-resource>
        <dxi-view type="day"></dxi-view>
        <dxi-view type="workWeek"></dxi-view>
        <dxi-view type="month"></dxi-view>
        <dxi-view type="agenda"></dxi-view>
      </dx-scheduler>

      <dx-tooltip
        #tooltipRef
        *ngIf="selectedAppointment"
        showEvent="click"
        [target]="selectedAppointment?.target"
      >
        <dk-scheduler-tooltip
          [selectedAppointmentData]="selectedAppointment?.data"
          (clickEditAppointment)="editSelectedAppointment()"
          (clickDeleteAppointment)="deleteSelectedAppointment($event)"
        ></dk-scheduler-tooltip>
      </dx-tooltip>
      <dx-speed-dial-action
        icon="add"
        [visible]="(screen.screenChanged | async)?.isXSmall"
        (onClick)="showAppointmentCreationForm()"
      ></dx-speed-dial-action>
    </div>
  </div>
</div>
